import { render, staticRenderFns } from "./QuickButton.vue?vue&type=template&id=6ec6b8b4&scoped=true"
import script from "./QuickButton.vue?vue&type=script&lang=js"
export * from "./QuickButton.vue?vue&type=script&lang=js"
import style0 from "./QuickButton.vue?vue&type=style&index=0&id=6ec6b8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6b8b4",
  null
  
)

export default component.exports